/**
 * Created by Alican Köker on 2018-02-26.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {
    IScatterAttentionConfig,
    ScatterAttentionController
} from "@nolimitcity/slot-game/bin/game/reelstoppresentation/scatterattention/ScatterAttentionController";
import {TimelineLite} from "gsap";
import {FreespinsLeftIndicator} from "../../freespinsleft/FreespinsLeftIndicator";
import {SymbolBurstAnimator} from "../../reelsymbol/SymbolBurstAnimator";
import {WildNudgeParsedGameData} from "../../server/data/WildNudgeParsedGameData";
import {WildNudgeGameConfig} from "../../WildNudgeGameConfig";
import {WildNudgeSoundConfig} from "../../WildNudgeSoundConfig";

export class WildNudgeScatterAttentionController extends ScatterAttentionController {

    private _attentionCounter:number = 0;
    private _isAttentionPlaying:boolean = false;
    private _winTimeline:TimelineLite;

    constructor(index:number, config:IScatterAttentionConfig) {
        super(index, config, false);
    }

    protected parseFeatureGameData(data:WildNudgeParsedGameData):void {
        super.parseFeatureGameData(data);
    }

    public onReelBounce(data:IReelStoppedData):void {
        if(this._gameData!.mode === GameMode.FREESPIN) {
            this.tryPlayScatterAttentionState(data.reelId);
            this.dispatchCompleteEvent(data.reelId);
            return;
        }

        if(data.reelId === 3) {
            // play no win on the attention symbols.
            if(!this._gameData!.freespinTriggeredThisSpin && this._isAttentionPlaying) {
                for(let reelId:number = 1; reelId < 3; reelId++) {
                    const symbolId:number = this._scatterPositions[reelId];
                    if(symbolId < 0) {
                        debugger;
                        throw new Error(`WildNudgeScatterAttentionController.onReelBounce()Play cancel attention on reel${reelId}, no scatter found!`);
                    }

                    const scatter:StateReelSymbol | null = Reels.getSymbol(reelId, symbolId);
                    if(scatter) {
                        scatter.changeState({
                            state : WildNudgeGameConfig.instance.SYMBOL_STATES.normal,
                            fadeInDuration : 0.1
                        });
                        EventHandler.dispatchEvent(new GameEvent(SymbolBurstAnimator.PLAY_SINGLE_SMOKE, reelId, symbolId));
                    }
                }
                EventHandler.dispatchEvent(new GameEvent(FreespinsLeftIndicator.FS_LEFT_INDICATOR_STOP_BLINKING));
                SlotGame.sound.playEffect(WildNudgeSoundConfig.instance.ATTENTION_EFFECT_FAIL);
                this.dispatchCompleteEvent(data.reelId);
                return;
            }
        }

        super.onReelBounce(data);
    }

    public playReelBouncingSound(data:IReelStoppedData):boolean {
        if(this._gameData!.scatterPositions![data.reelId] === -1) {
            return false;
        }

        //for freespin mode
        if(this._gameData!.mode === GameMode.FREESPIN) {
            SlotGame.sound.playEffect(WildNudgeSoundConfig.instance.SCATTER_LANDING_3);
            return false;
        }

        //for normalGame mode
        if(this._isAttentionPlaying || this._freespinTriggered) {
            SlotGame.sound.playEffect((<any>WildNudgeSoundConfig.instance)[`SCATTER_LANDING_${data.reelId}`]);
        } else {
            SlotGame.sound.playEffect(WildNudgeSoundConfig.instance.SCATTER_LANDING_1);
        }

        return false;
    }

    protected playAttentionAnimation(data:IReelStoppedData):void {
        this._attentionCounter++;

        // Start to play on the second scatter.
        if(this._attentionCounter > 1) {
            for(let reelId:number = 0; reelId <= data.reelId; reelId++) {
                this.tryPlayScatterAttentionState(reelId);
            }
            EventHandler.dispatchEvent(new GameEvent(FreespinsLeftIndicator.FS_LEFT_INDICATOR_BLINK_LIGHTS));

            this._isAttentionPlaying = true;
        }

        this.dispatchCompleteEvent(data.reelId);
    }

    protected playWinAttentionAnimation(data:IReelStoppedData):void {
        // no need to kill win timeline because there are max 3 scatters.
        this._winTimeline = new TimelineLite({paused : true});

        this._winTimeline.add(() => EventHandler.dispatchEvent(new GameEvent(FreespinsLeftIndicator.FS_ANTICIPATION_LIGHTS_ON)));

        for(let reelId:number = 0; reelId <= data.reelId; reelId++) {
            if(this._scatterPositions[reelId] === -1) {
                continue;
            }

            const scatter:StateReelSymbol | null = Reels.getSymbol(reelId, this._scatterPositions[reelId]);
            if(!scatter) {
                debugger;
                continue;
            }

            this._winTimeline.add(scatter.changeState({
                state : WildNudgeGameConfig.instance.SYMBOL_STATES.win,
                fadeInDuration : 0.1
            }), 0);
            this._winTimeline.add(SymbolBurstAnimator.playFireWin(reelId, this._scatterPositions[reelId]), 0);
        }
        this._winTimeline.add(() => this.dispatchCompleteEvent(data.reelId));
        this._winTimeline.play();
    }

    private tryPlayScatterAttentionState(reelId:number):boolean {
        if(this._scatterPositions[reelId] === -1) {
            return false;
        }

        const scatter:StateReelSymbol | null = Reels.getSymbol(reelId, this._scatterPositions[reelId]);
        if(scatter) {
            scatter.changeState({
                state : WildNudgeGameConfig.instance.SYMBOL_STATES.attention,
                fadeInDuration : 0.1,
                replay : false
            });
            scatter.parent.addChild(scatter);
            return true;
        }

        return false;
    }

    protected resetFeature():void {
        super.resetFeature();
        this._attentionCounter = 0;
        this._isAttentionPlaying = false;
    }
}